import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CheckoutContext from '../../lib/CheckoutContext';
import PromoCode from '../PromoCode';
import HardwareFirstPromoApplied from './HardwareFirstPromoApplied';
import HardwareFirstPromoOffer from './HardwareFirstPromoOffer';
import styles from './HardwareFirstCartPromo.module.scss';

/**
 * The cart's code entry: the field and the live promotion's one-tap chip, or the applied code's row
 * once one is on. Desktop shows it inside the order summary; mobile shows it in its own card under
 * the items, where the summary sits below the fold.
 */
export default function HardwareFirstCartPromo() {
  const { t } = useTranslation();
  const { cart } = useContext(CheckoutContext);
  // a referral or gift card keeps PromoCode's own rows, which know how to name and remove them
  const couponOnly = !!cart.couponCode && !cart.referralCode && !cart.redeemedGiftCardCode;

  return (
    <div className={styles.promo}>
      {couponOnly ? (
        <HardwareFirstPromoApplied />
      ) : (
        <>
          <PromoCode placeholder={t('promo_code')} />
          <HardwareFirstPromoOffer />
        </>
      )}
    </div>
  );
}
